
import { defineComponent } from 'vue'
import NavbarItemContent from './NavbarItemContent.vue'

export default defineComponent({
  name: 'ExternalLink',
  components: {
    NavbarItemContent
  },
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    },
    url: {
      type: String,
      required: true
    }
  },
  setup () {
    return {}
  }
})
